import { useMutation } from '@tanstack/react-query';
import { createTrailerToDockTransaction } from '../../api/production-request-api/index.js';

/**
 * @typedef {object} TrailerToDockInput
 * @property {string} dock - The selected dock value
 * @property {string} organizationCode - The WMS organization code for the plant
 * @property {string} trailerNumber - The trailer number entered by the user
 * @property {string} carrierName - The selected carrier name
 */

/**
 * Hook containing mutation function for creating a Trailer To Dock transaction.
 */
export const useCreateTrailerToDockTransaction = () =>
  useMutation({
    /**
     * mutateFn - Function to call the createTrailerToDockTransaction api.
     * @param {TrailerToDockInput} input - The inputs for the Trailer To Dock transaction.
     */
    mutationFn: (input) => createTrailerToDockTransaction(input),
  });
